/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { makeStyles, Box } from "@material-ui/core";
import { AiOutlineTag } from "react-icons/ai";
import _ from "lodash";
import FiltersSelectComponent from "app/filters/FiltersSelectComponent";
import { filterCollectionByFilterName } from "lib/utils/competitors";
import CompetitorGroupByComponent from "./CompetitorGroupByComponent";

const useStyles = makeStyles(() => ({
  scenarioFiltersContainer: {
    borderRight: "1px solid #e4e4e4",
    width: "30%",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    gridAutoRows: "55px",
  },
}));
export default function CompetitorFilters({
  sliderDataByCategories,
  competitorsFilters,
  setCompetitorFilters,
  groupByEnabled = true,
}) {
  const classes = useStyles();

  let categories = [];
  const companies = [];
  const companiesIds = [];
  const brands = new Map();

  const filteredCategories = filterCollectionByFilterName(
    "category",
    sliderDataByCategories,
    competitorsFilters
  );
  categories = filteredCategories.map((category) => ({
    id: category.id,
    label: category.label,
  }));

  filteredCategories.forEach((category) => {
    const filteredCompanies = filterCollectionByFilterName(
      "company",
      category.companies,
      competitorsFilters
    );
    filteredCompanies.forEach((company) => {
      if (company.id && !companiesIds.includes(company.id)) {
        companiesIds.push(company.id);
        companies.push({
          id: company.id,
          label: company.label,
        });
      }
    });

    filteredCompanies.forEach((company) => {
      const filteredBrands = filterCollectionByFilterName(
        "brand",
        company.brands,
        competitorsFilters
      );
      filteredBrands.forEach(
        (brand) =>
          brand.id &&
          brands.set(brand.id, {
            id: brand.id,
            label: brand.label,
          })
      );
    });
  });

  const sortedCategories = _.sortBy(categories, (category) => category.label);
  const sortedCompanies = _.sortBy(companies, (company) => company.label);
  const sortedBrands = _.sortBy(
    Array.from(brands.values()),
    (brand) => brand.label
  );

  const handleFilterChange = (selection) => {
    setCompetitorFilters((prev) => ({ ...prev, ...selection }));
  };

  useEffect(() => {
    if (competitorsFilters.groupBy.key === "category-company")
      handleFilterChange({ brand: "" });
  }, [competitorsFilters.groupBy.key]);

  return (
    <Box className={classes.scenarioFiltersContainer}>
      {groupByEnabled && (
        <CompetitorGroupByComponent
          competitorsFilters={competitorsFilters}
          handleChange={handleFilterChange}
        />
      )}
      <FiltersSelectComponent
        inputData={{
          key: "category",
          label: "Category",
          type: "normal",
          data: sortedCategories,
          icon: <AiOutlineTag size={22} />,
        }}
        filters={competitorsFilters}
        sort="asc"
        handleChange={handleFilterChange}
      />
      <FiltersSelectComponent
        inputData={{
          key: "company",
          label: "Company",
          type: "normal",
          data: sortedCompanies,
          icon: <AiOutlineTag size={22} />,
        }}
        filters={competitorsFilters}
        sort="asc"
        handleChange={handleFilterChange}
      />
      {competitorsFilters.groupBy.key === "category-company-brand" && (
        <FiltersSelectComponent
          inputData={{
            key: "brand",
            label: "Brand",
            type: "normal",
            data: sortedBrands,
            icon: <AiOutlineTag size={22} />,
          }}
          filters={competitorsFilters}
          sort="asc"
          handleChange={handleFilterChange}
        />
      )}
    </Box>
  );
}
